import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { BookOpen, ChevronLeft, ChevronRight } from 'lucide-react';
const pages = [{
  src: 'https://cdn.magicpatterns.com/uploads/moda6d48Y5cTmtG3HQrvG3/IMG_3031.jpg',
  caption: 'Tu Historia con el Dinero — Capítulo 1'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/52zM9FBQRxrteXiymyGDdf/IMG_3032.jpg',
  caption: 'La Flexibilidad Relacional: El Superpoder del Comunicador PNL'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/ey8Fvzn79NqrVADkhBsd6L/IMG_3033.jpg',
  caption: 'El Modelo de los 4 Cuerpos'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/qcEC44kyrivsESjbb8peKK/IMG_3035.jpg',
  caption: 'El Costo Biológico de Vivir en Modo Crisis'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/b1T6ZzAXbVSSthkeWHSpzY/IMG_3036.jpg',
  caption: 'El Sistema Emocional en 3 Capas'
}];
export function InsideLook() {
  const [current, setCurrent] = useState(0);
  const [direction, setDirection] = useState(0);
  const goTo = (index: number) => {
    setDirection(index > current ? 1 : -1);
    setCurrent(index);
  };
  const prev = () => {
    setDirection(-1);
    setCurrent(c => c === 0 ? pages.length - 1 : c - 1);
  };
  const next = () => {
    setDirection(1);
    setCurrent(c => c === pages.length - 1 ? 0 : c + 1);
  };
  const variants = {
    enter: (dir: number) => ({
      x: dir > 0 ? 300 : -300,
      opacity: 0
    }),
    center: {
      x: 0,
      opacity: 1
    },
    exit: (dir: number) => ({
      x: dir > 0 ? -300 : 300,
      opacity: 0
    })
  };
  return <section className="py-20 md:py-32 px-4 bg-dark-card/30 relative overflow-hidden" data-id="element-184">
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-gold/20 to-transparent" data-id="element-185" />

      <div className="max-w-4xl mx-auto" data-id="element-186">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-187">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-gold/10 mb-6" data-id="element-188">
            <BookOpen className="w-8 h-8 text-gold" data-id="element-189" />
          </div>
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-white mb-4" data-id="element-190">
            MIRÁ LO QUE HAY ADENTRO
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto" data-id="element-191">
            Páginas reales del Sistema Soberano. Contenido profesional,
            aplicable y diseñado para transformar.
          </p>
        </motion.div>

        {/* Carousel */}
        <div className="relative" data-id="element-192">
          {/* Main image */}
          <div className="relative aspect-[3/4] max-h-[600px] mx-auto overflow-hidden rounded-xl border border-dark-border bg-dark-card" data-id="element-193">
            <AnimatePresence initial={false} custom={direction} mode="wait" data-id="element-194">
              <motion.img key={current} src={pages[current].src} alt={pages[current].caption} custom={direction} variants={variants} initial="enter" animate="center" exit="exit" transition={{
              duration: 0.35,
              ease: 'easeInOut'
            }} className="absolute inset-0 w-full h-full object-cover object-top" data-id="element-195" />
            </AnimatePresence>

            {/* Caption overlay */}
            <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-dark via-dark/80 to-transparent p-6 pt-16" data-id="element-196">
              <p className="text-white font-medium text-lg" data-id="element-197">
                {pages[current].caption}
              </p>
              <p className="text-gold-light text-sm mt-1" data-id="element-198">
                {current + 1} / {pages.length}
              </p>
            </div>
          </div>

          {/* Navigation arrows */}
          <button onClick={prev} className="absolute left-2 md:-left-14 top-1/2 -translate-y-1/2 w-10 h-10 md:w-12 md:h-12 rounded-full bg-dark-card/90 border border-dark-border flex items-center justify-center text-white hover:border-gold/50 hover:text-gold transition-colors z-10" aria-label="Anterior" data-id="element-199">
            <ChevronLeft className="w-5 h-5 md:w-6 md:h-6" data-id="element-200" />
          </button>
          <button onClick={next} className="absolute right-2 md:-right-14 top-1/2 -translate-y-1/2 w-10 h-10 md:w-12 md:h-12 rounded-full bg-dark-card/90 border border-dark-border flex items-center justify-center text-white hover:border-gold/50 hover:text-gold transition-colors z-10" aria-label="Siguiente" data-id="element-201">
            <ChevronRight className="w-5 h-5 md:w-6 md:h-6" data-id="element-202" />
          </button>
        </div>

        {/* Dot indicators */}
        <div className="flex justify-center gap-2 mt-6" data-id="element-203">
          {pages.map((_, index) => <button key={index} onClick={() => goTo(index)} className={`w-2.5 h-2.5 rounded-full transition-all ${index === current ? 'bg-gold w-8' : 'bg-dark-border hover:bg-gray-500'}`} aria-label={`Ir a imagen ${index + 1}`} data-id="element-204" />)}
        </div>

        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="text-center text-gray-500 text-sm mt-6 italic" data-id="element-205">
          480+ páginas de contenido real — esto es solo una muestra.
        </motion.p>
      </div>
    </section>;
}